const sortInsurance = insurance =>
  insurance.sort((a, b) => {
    const aStatus = a['Insurance Status'] || 'Active';
    const bStatus = b['Insurance Status'] || 'Active';
    let aWeight;
    let bWeight;
    switch (`${a['Order Benefits']} ${aStatus}`) {
      case 'Primary Active':
        aWeight = 1;
        break;
      case 'Primary Inactive':
        aWeight = 2;
        break;
      case 'Secondary As Primary Active':
        aWeight = 3;
        break;
      case 'Secondary As Primary Inactive':
        aWeight = 4;
        break;
      case 'Secondary Active':
        aWeight = 5;
        break;
      case 'Secondary Inactive':
        aWeight = 6;
        break;
      case 'Tertiary Active':
        aWeight = 7;
        break;
      case 'Tertiary Inactive':
        aWeight = 8;
        break;
      default:
        aWeight = 9;
    }
    switch (`${b['Order Benefits']} ${bStatus}`) {
      case 'Primary Active':
        bWeight = 1;
        break;
      case 'Primary Inactive':
        bWeight = 2;
        break;
      case 'Secondary As Primary Active':
        bWeight = 3;
        break;
      case 'Secondary As Primary Inactive':
        bWeight = 4;
        break;
      case 'Secondary Active':
        bWeight = 5;
        break;
      case 'Secondary Inactive':
        bWeight = 6;
        break;
      case 'Tertiary Active':
        bWeight = 7;
        break;
      case 'Tertiary Inactive':
        bWeight = 8;
        break;
      default:
        bWeight = 9;
    }
    if (aWeight === bWeight) {
      return b.ID - a.ID;
    }
    return aWeight - bWeight;
  });

export default sortInsurance;



// WEBPACK FOOTER //
// ./src/utils/sortInsurance.js